export const  FileTypes = [
    'application/pdf',
    'application/msword',
    'application/vnd.ms-powerpoint',
    'applicatiapplication/vnd.openxmlformats-officedocument.presentationml.presentation',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'image/jpg',
    'image/jpeg',
    'image/png',
    'image/tiff',
    'image/bmp',
    'text/plain',
    'text/html',
    'text/htm'
]